import { render, staticRenderFns } from "./OrderedProducts.vue?vue&type=template&id=20d53179&scoped=true"
import script from "./OrderedProducts.vue?vue&type=script&lang=js"
export * from "./OrderedProducts.vue?vue&type=script&lang=js"
import style0 from "./OrderedProducts.vue?vue&type=style&index=0&id=20d53179&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d53179",
  null
  
)

export default component.exports